const getSite = ({ site }) => {
  if (site) {
    const getSiteRecord = id => site.find(record => record.id === id);
    return {
      aboutHTML: getSiteRecord('about') ? getSiteRecord('about').html : null,
      footerHTML: getSiteRecord('footer') ? getSiteRecord('footer').html : null,
      pressLinks: getSiteRecord('press') ? getSiteRecord('press').links : [],
      adminUsers: getSiteRecord('admin') ? getSiteRecord('admin').users : [],
      contactLinks: getSiteRecord('contact') ? getSiteRecord('contact').links : [],
      options: getSiteRecord('options') || {},
    };
  }
  return null;
};

export default {
  getMode: state => state.mode,
  getSite: state => getSite(state),
};
